export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
        /* eslint-disable */
        // $.ajax({
        //   url: frontendajax.ajaxurl,
        //   method: 'POST',
        //   data: { 
        //     'action': 'get_ajax',
        //   },
        //   success: function (data) {
        //     console.log(data);
        //   },
        //   complete: function () {
            
        //   },
        // });
        /* eslint-enable */
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js